import React from "react"
import { componentStyles } from "@mallardbay/lib-react-components"

import { Text } from "~components/shared/todo-lib-react-components/text"
import COPY from "~config/copy-constants"

interface Props {
    readonly outfitterName?: string
}

export default function PackageSectionsTitle({ outfitterName }: Props) {
    const styles = useStyles()
    const title = `${COPY.BOOK_WITH} ${outfitterName}`

    if (!outfitterName) return null

    return <Text style={styles.title}>{title}</Text>
}

function useStyles() {
    return componentStyles({
        title: {
            marginTop: 0,
            fontWeight: "bold",
            fontSize: "19px",
        },
    })
}
